module.exports = __webpack_public_path__ + "static/media/BookOpenTextHover.56b9c73b.svg";